import { Action, createReducer, on } from "@ngrx/store";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { InvoicesState } from "../../models/mp-admin/invoices-state";

export const initialInvoicesState: InvoicesState = {
	invoices: [],
	loading: false,
	error: null
};

const reducer = createReducer(
	initialInvoicesState,

	// Get invoices
	on(MpAdminActions.invoices.getApi, (state) => ({
		...state,
		loading: true,
		error: null
	})),

	on(MpAdminActions.invoices.getSuccess, (state, { invoices }) => ({
		...state,
		invoices,
		loading: false
	})),

	on(MpAdminActions.invoices.getFail, (state, { error }) => ({
		...state,
		loading: false,
		error
	})),

	// Create invoice
	on(MpAdminActions.invoices.createApi, (state) => ({
		...state,
		loading: true,
		error: null
	})),

	on(MpAdminActions.invoices.createSuccess, (state, { invoiceCreationResponse }) => {
		if (invoiceCreationResponse?.warnings?.length > 0) {
			// If there are warnings, only update loading state but don't add the invoice
			return {
				...state,
				loading: false
			};
		}
		return {
			...state,
			invoices: [...state.invoices, invoiceCreationResponse?.invoice],
			loading: false
		};
	}),
	on(MpAdminActions.invoices.createFail, (state, { error }) => ({
		...state,
		loading: false,
		error
	})),

	// Send invoice
	on(MpAdminActions.invoices.sendApi, (state) => ({
		...state,
		loading: true,
		error: null
	})),

	on(MpAdminActions.invoices.sendSuccess, (state, { invoice }) => ({
		...state,
		invoices: state.invoices.map((inv) => (inv.id === invoice.id ? invoice : inv)),
		loading: false
	})),

	on(MpAdminActions.invoices.sendFail, (state, { error }) => ({
		...state,
		loading: false,
		error
	})),

	// Pay invoice
	on(MpAdminActions.invoices.payApi, (state) => ({
		...state,
		loading: true,
		error: null
	})),

	on(MpAdminActions.invoices.paySuccess, (state, { invoice }) => ({
		...state,
		invoices: state.invoices.map((inv) => (inv.id === invoice.id ? invoice : inv)),
		loading: false
	})),

	on(MpAdminActions.invoices.payFail, (state, { error }) => ({
		...state,
		loading: false,
		error
	})),

	// Delete invoice
	on(MpAdminActions.invoices.deleteApi, (state) => ({
		...state,
		loading: true,
		error: null
	})),

	on(MpAdminActions.invoices.deleteSuccess, (state, { invoiceId }) => ({
		...state,
		invoices: state.invoices.filter((invoice) => invoice.id !== invoiceId),
		loading: false
	})),

	on(MpAdminActions.invoices.deleteFail, (state, { error }) => ({
		...state,
		loading: false,
		error
	}))
);

export function invoicesReducer(state: InvoicesState | undefined, action: Action) {
	return reducer(state, action);
}
